import React, { useState, useEffect } from 'react';
import './Navigation.css';
import { FaAngleDown } from 'react-icons/fa';

const Navigation = ({ openContactModal }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Detectar scroll para cambiar el estilo de la barra
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Función para hacer scroll suave a una sección
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80; // Altura del header
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    // Cerrar menú móvil si está abierto
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false); // Cerrar dropdown al navegar a otra sección
  };

  // Cerrar el dropdown cuando se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest('.nav-link-negocios')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const menuItems = [
    { id: 'funcionalidades', label: 'Funcionalidades' },
    { id: 'trainer-max-ai', label: 'Trainer Max AI' },
    { id: 'faq', label: 'Preguntas frecuentes' },
    { id: 'precios', label: 'Precios' },

  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav">
          <div className="nav-left">
            <div
              onClick={() => window.location.href = '/'}
              className="logo">

              <img
                src="/tmax.webp"
                alt="Trainer Max"
                className="logo-img"
                loading="eager"
              />
            </div>
            <nav className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  className={`nav-link ${item.id === 'negocios' ? 'nav-link-negocios' : ''}`}
                  onMouseEnter={() => item.id === 'negocios' && setIsDropdownOpen(true)}
                  onMouseLeave={() => item.id === 'negocios' && setIsDropdownOpen(false)}
                  onClick={() => {
                    if (item.id === 'negocios') {
                      // En mobile, alternar el dropdown al hacer clic en el botón principal
                      if (window.innerWidth <= 1024) {
                        setIsDropdownOpen(!isDropdownOpen);
                      }
                    } else {
                      scrollToSection(item.id);
                      setIsDropdownOpen(false);
                    }
                  }}
                >
                  {item.label}
                  {item.id === 'negocios' && (
                    <span
                      className="dropdown-toggle-icon"
                      onClick={(e) => {
                        e.stopPropagation(); // Evitar que el clic se propague al padre
                        setIsDropdownOpen(!isDropdownOpen);
                      }}
                    >
                      <FaAngleDown className={`arrow-icon ${isDropdownOpen ? 'rotated' : ''}`} />
                    </span>
                  )}
                  {item.submenu && isDropdownOpen && item.id === 'negocios' && (
                    <div className="dropdown-menu">
                      {item.submenu.map((subItem) => (
                        <a
                          key={subItem.id}
                          href={subItem.url}
                          className="dropdown-item"
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            setIsDropdownOpen(false);
                          }}
                        >
                          {subItem.label}
                        </a>
                      ))}
                    </div>
                  )}
                </button>
              ))}
            </nav>
          </div>
          <div className="nav-actions">
            <button
              className="btn-trial"
              onClick={() => window.location.href = 'https://admin.trainer-max.com/prueba-tmax'}
            >
              PRUEBA GRATIS
            </button>
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navigation;
